import { styled } from '@mui/system'
import { Table, TableCell, TableContainer, TableRow } from '@mui/material'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const DataGridTableContainer = styled(TableContainer)(({ theme }) => ({
  width: '100%',
  overflowX: 'initial',
}))

export const DataGridTableStyled = styled(Table)(({ theme }) => ({
  minWidth: '35rem',
}))

export const DataGridTableRowHead = styled(TableRow)(({ theme }) => ({
  position: 'sticky',
  top: '0',
  zIndex: '2',
  background: theme.palette.primary.light,
}))

export const DataGridTableLoaderDiv = styled('div')(({ theme }) => ({
  top: '13rem',
  right: '0',
  left: '0',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  height: '49rem',
  maxWidth: 'var(--viewportWidth)',
  '& svg': {
    height: '3rem',
    width: '3rem',
  },
}))

export const DataGridTableHeaderCell = styled(TableCell)(({ theme }) => ({
  position: 'relative',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  color: 'white',
  '&:nth-last-of-type(-n+2)': {
    padding: '0 8rem',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '100%',
    transform: 'translateY(-50%)',
    height: '1.5rem',
    width: '2px',
    background: 'rgba(255,255,255,0.3)',
  },
}))

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */
